import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { LearningCompartments, learningStorageKey } from '..';

export class CoursesListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.UserInitialized)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(learningStorageKey)
    private readonly cache: DataCache<LearningCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('courses');
        } else {
          this.cache.reset('courses');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
